import { portal as portalService } from "../../services/index.js";

const state = {
  view: {},
  styles: {},
  isMobile: false,
  portal: null
};

const getters = {
  view: state => state.view,
  styles: state => state.styles
};

const mutations = {
  setView(state, view) {
    state.view = view;
  },
  setStyle(state, style) {
    state.styles[style.id] = style.style;
  },
  setMobile(state, isMobile) {
    state.isMobile = isMobile;
  },
  setPortal(state, portal) {
    state.portal = portal;
  }
};

const actions = {
  get(context) {
    return portalService.get().then(data => {
      context.commit("setView", data);
    });
  },
  setStyle(context, style) {
    context.commit("setStyle", style);
  },
  setPortal(context, portal) {
    context.commit("setPortal", portal);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
